import { InteractiveMapMarker } from 'components/InteractiveMap';
import useLocations from './useLocations';

export default function useLocationMarkers() {
  const locationData = useLocations().locations;
  const locationMarkers = locationData
    ?.filter((location) => location.latitude && location.longitude)
    ?.map((location) => ({
      groupId: location.groupId,
      locationId: location.id,
      position: [location.latitude, location.longitude],
      label: location.name,
    })) as InteractiveMapMarker[];

  return locationMarkers;
}
